import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useBannerInView } from '@client/hooks/useBannerInView'
import { useBannerViewAnalytics } from '@client/hooks/useBannerViewAnalytics'
import { getBanners } from '@client/selectors/appSelectors'
import { getBannersByPlatform } from '@client/utils/getBannersByPlatform'
import { getRandomInt } from '@client/utils/getRandomInt'
import { makeClassName } from '@client/utils/makeClassName'
import { sendBannerClickAnalytics } from '@client/utils/sendBannerClickAnalytics'

import { Lazy } from '@meduza/ui-kit-2'

import styles from './DFPBanner.module.css'

export const DFPBanner = () => {
  const bannersData = useSelector(getBanners)

  const dispatch = useDispatch()

  const { ref, inView } = useBannerInView()

  const position = 'bottom'

  const banners = getBannersByPlatform(bannersData?.bottom)
  const random = getRandomInt(0, banners?.length - 1)
  const banner = banners?.[random]

  useBannerViewAnalytics({
    inView,
    banner,
    position,
    dispatch
  })

  const handleBannerClick = () => {
    sendBannerClickAnalytics(banner, position, dispatch)
  }

  if (!banner) {
    return null
  }

  return (
    <div
      className={makeClassName([
        [styles.root, true],
        [styles[banner.size_desktop], true]
      ])}
      ref={ref}
    >
      {banner && (
        <a
          className={styles.link}
          href={banner.url}
          target="_blank"
          rel="noreferrer"
          ref={ref}
          onClick={handleBannerClick}
        >
          <Lazy>
            <picture className={styles.picture}>
              <source srcSet={banner.desktop} media="(min-width: 1000px)" />
              <source srcSet={banner.mobile} media="(max-width: 999px)" />
              <img
                src="data:image/gif;base64,R0lGODlhAQABAPAAAPLy8gAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="
                alt={banner.alt}
              />
            </picture>
          </Lazy>
        </a>
      )}
    </div>
  )
}
